/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 76
// module chunks = 0 2